import React, { useEffect, useState } from 'react';
import {
  Paper,
  Text,
  Stack,
  Container,
  Grid,
  ThemeIcon,
  createStyles,
  Avatar,
  Badge
} from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import EditUserForm from '../components/forms/EditUserForm';
import { IconMedal, IconPhoto, IconTrophy, IconTrophyFilled } from '@tabler/icons-react';
import useInfoModal from '../hooks/useInfoModal';
import { MockAppDataService as AppDataService } from '../services/MockAppDataService';
import { createImageUrl } from '../utils/CommonUtils';
import { update } from '../redux/slices/authSlice';
import { MODAL_TYPE_ENUM } from '../enums/CommonEnums';

const useStyles = createStyles((theme) => ({
  avatar: {
    cursor: 'pointer',
  },
  fileIcon: {
    zIndex: 999
  }
}));

const UserProfileScreen = () => {
  const { user } = useSelector((state) => state.auth);
  const openModal = useInfoModal();
  const { classes, theme } = useStyles();
  const dispatch = useDispatch();

  const triggerProfileImageSelect = () => {
    var element = document.getElementById('profile-pic-input');
    element.click();
  }

  const handleUploadProfilePicture = async (e) => {
    try {
      e.preventDefault();

      if(!e.target?.files || e.target.files.length === 0) return;

      var data = new FormData();

      data.append('FormFile', e.target.files[0]);

      const response = await AppDataService.UploadProfileImage(data);
      const responseData = response.getResponse();

      if(response.hasError()) openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, responseData.error.message);
      else {
        openModal(MODAL_TYPE_ENUM.GENERAL_SUCCESS, 'Your profile image has been updated.');

        const userUpdated = {...user};
        userUpdated.profileImage = responseData.data;

        dispatch(update(userUpdated));
      } 
    }
    catch(e) {
      openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, e.message)
    }
  }

  return (
    <Container size="lg" py="xl">
      <Grid>
        <Grid.Col span={4}>
          <Paper maw={400} p={25} shadow='md' radius='md'>
            <Stack align='center'>
              <Avatar color='blue' src={createImageUrl(user.profileImage?.imageRaw) || null} className={classes.avatar} size='xl' radius={40} />
              <ThemeIcon radius="lg" size="lg" mt={-25} className={classes.fileIcon} color='gray'>
                <IconPhoto />
                <input id="profile-pic-input" type="file" name="profileImage" style={{ display: 'none' }} accept=".png,.jpg,.jpeg" />
              </ThemeIcon>
              <Text ta='center' fw={700} fz={22}>{user.firstName} {user.lastName}</Text>
              <Text ta='center' c='dimmed' fz={18}>{user.title ? `${user.title} • ${user.companyName}` : user.companyName}</Text>
              {
                user.isAdmin && <Badge radius='sm' miw={150} variant='gradient' gradient={{ from: 'grape', to: 'violet' }} size='lg' color='violet'>ADMIN</Badge>
              }
            </Stack>
          </Paper>
        </Grid.Col>
        <Grid.Col span={8}>
          <Paper p={25} shadow='md' radius='md'>
            <EditUserForm user={user} />
          </Paper>
        </Grid.Col>
      </Grid>
    </Container>
  )
}

export default UserProfileScreen;